export const todaysTopFive = {
  date: new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }),
  category: 'Daily Essentials',
  items: [
    {
      rank: 1,
      title: 'Morning Hydration Protocol',
      description: 'Start your day with 32oz of water with electrolytes and lemon before any caffeine. This simple habit jumpstarts metabolism, aids digestion, and rehydrates your body after sleep.',
      icon: 'ri-drop-line',
    },
    {
      rank: 2,
      title: 'Compound Movement Focus',
      description: 'Prioritize multi-joint exercises like squats, deadlifts, and presses. These movements recruit more muscle fibers, burn more calories, and build functional strength efficiently.',
      icon: 'ri-fitness-line',
    },
    {
      rank: 3,
      title: 'Protein Timing Optimization',
      description: 'Consume 30-40g of protein within 2 hours post-workout and aim for 0.8-1g per pound of bodyweight daily. Proper protein timing maximizes muscle protein synthesis and recovery.',
      icon: 'ri-restaurant-line',
    },
    {
      rank: 4,
      title: 'Sleep Quality Enhancement',
      description: 'Maintain 7-9 hours of quality sleep with consistent bedtime routine. Sleep is when growth hormone peaks and recovery happens - it is non-negotiable for progress.',
      icon: 'ri-moon-line',
    },
    {
      rank: 5,
      title: 'Progressive Overload Tracking',
      description: 'Log every workout and aim to increase weight, reps, or volume weekly. Progressive overload is the fundamental principle driving all strength and muscle gains.',
      icon: 'ri-line-chart-line',
    },
  ],
};

export const topFiveArchive = [
  {
    date: 'December 20, 2024',
    category: 'Peptide Stacks',
    items: [
      { rank: 1, title: 'BPC-157 + TB-500 Recovery Stack', description: 'Ultimate combination for injury recovery and tissue repair' },
      { rank: 2, title: 'Ipamorelin + CJC-1295 Growth Stack', description: 'Synergistic GH release for muscle growth and fat loss' },
      { rank: 3, title: 'BPC-157 Solo Protocol', description: 'Targeted healing for specific injuries and inflammation' },
      { rank: 4, title: 'TB-500 Flexibility Protocol', description: 'Enhanced mobility and injury prevention' },
      { rank: 5, title: 'Melanotan II Aesthetic Stack', description: 'Tanning and body composition benefits' },
    ],
  },
  {
    date: 'December 19, 2024',
    category: 'Workout Splits',
    items: [
      { rank: 1, title: 'Push/Pull/Legs (PPL)', description: 'Classic 6-day split for maximum volume and recovery' },
      { rank: 2, title: 'Upper/Lower 4-Day', description: 'Balanced frequency for strength and hypertrophy' },
      { rank: 3, title: 'Full Body 3-Day', description: 'Efficient training for busy schedules' },
      { rank: 4, title: 'Bro Split 5-Day', description: 'Traditional bodybuilding approach with dedicated muscle days' },
      { rank: 5, title: 'PHAT (Power Hypertrophy)', description: 'Combines strength and size training optimally' },
    ],
  },
  {
    date: 'December 18, 2024',
    category: 'Nutrition Strategies',
    items: [
      { rank: 1, title: 'Carb Cycling', description: 'Alternate high and low carb days for fat loss and performance' },
      { rank: 2, title: 'Intermittent Fasting 16:8', description: 'Time-restricted eating for metabolic benefits' },
      { rank: 3, title: 'Macro Tracking', description: 'Precise nutrition control for specific goals' },
      { rank: 4, title: 'Intuitive Eating', description: 'Sustainable approach based on hunger cues' },
      { rank: 5, title: 'Meal Prep Sunday', description: 'Batch cooking for consistency and convenience' },
    ],
  },
];